import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Support } from '@/components';

import { LockOutlined } from '@ant-design/icons';

import styles from './LockedAccount.module.sass';

interface LockedAccountProps {}

const LockedAccount: FC<LockedAccountProps> = (props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.locked}>
      <div className={styles.wrapper}>
        <div className={styles.row}>
          <div className={styles.problem}>
            <h2 className={styles.title}>
              {t('translation.account_is_locked')}
            </h2>
            <div className={styles.icon}>
              <LockOutlined />
            </div>
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.support}>
            <span className={styles.text}>
              {t('translation.contact_support')}
            </span>
            <Support />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LockedAccount;
